module.exports = __webpack_public_path__ + "static/media/Calendar-dark.a613f6b1.svg";